import { useEffect, useState } from "react";

const STORAGE_KEY = "unicornation_cookie_consent";

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const stored = window.localStorage.getItem(STORAGE_KEY);

        if (!stored) {
            setVisible(true);
            return;
        }

        // If already accepted previously, enable analytics immediately
        if (stored === "accepted") {
            window.gtag?.("consent", "update", {
                analytics_storage: "granted",
            });
        }
    }, []);

    function handleAccept() {
        window.localStorage.setItem(STORAGE_KEY, "accepted");

        // Enable analytics from this moment onward
        window.gtag?.("consent", "update", {
            analytics_storage: "granted",
        });

        setVisible(false);
    }

    if (!visible) return null;

    return (
        <div className="fixed inset-x-0 bottom-0 z-50">
            <div className="mx-auto max-w-4xl mb-4 px-4">
                <div className="rounded-2xl bg-slate-900 text-slate-50 p-4 shadow-lg flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <p className="text-sm leading-relaxed">
                        We use cookies and Google Analytics to improve your experience and
                        understand how UnicorNation is used. By using this site, you agree
                        to our use of cookies as described in our Privacy Policy.
                    </p>
                    <button
                        onClick={handleAccept}
                        className="mt-1 sm:mt-0 inline-flex items-center justify-center rounded-full px-4 py-2 text-sm font-semibold bg-pink-400 hover:bg-pink-500 transition"
                    >
                        Ok
                    </button>
                </div>
            </div>
        </div>
    );
}
